module.exports = __webpack_public_path__ + "static/media/IMG_20190510_075155.72a97d87.jpg";